import { Modal, Row } from 'antd';
import { useState, useRef } from 'react';
import { MyText } from '../../../components/common';
import { AudioPlayIcon, AudioPauseIcon, AudioIcon, SpeakerIcon } from '../../../assets';
import { AudioContainer, PlayPauseButton, ProgressBar, StyledButton } from './style';
import {useTranslation} from "react-i18next";

interface MaterialModalProps {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}

const audioFiles = [
  { title: 'Название 1', src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3', duration: '2:39' },
  { title: 'Название 2', src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3', duration: '1:51' },
  { title: 'Название 3', src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3', duration: '1:51' },
];

const formatTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export const MaterialModal: React.FC<MaterialModalProps> = ({ visible, onOk, onCancel }) => {
  const [playing, setPlaying] = useState<string | null>(null);
  const [currentTime, setCurrentTime] = useState<number[]>(audioFiles.map(() => 0)); 
  const audioRefs = useRef<HTMLAudioElement[]>([]);
  const [durations, setDurations] = useState<number[]>(audioFiles.map(() => 0));
  const {t} = useTranslation("common")

  const handlePlayPause = (index: number, src: string) => {
    const currentAudio = audioRefs.current[index];
  
    if (playing === src) {
      currentAudio?.pause();
      setPlaying(null);
    } else {
      audioRefs.current.forEach((audio, i) => {
        if (audio && i !== index) {
          audio.pause();
        }
      });
      currentAudio?.play().catch((error) => {
        console.error("Playback failed:", error);
      });
      setPlaying(src);
    }
  };
  
  const handleTimeUpdate = (index: number) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      setCurrentTime((prev) => {
        const updatedTimes = [...prev];
        updatedTimes[index] = currentAudio.currentTime;
        return updatedTimes;
      });
    }
  };
  
  const handleSeek = (index: number, value: number) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      const newTime = (value / 100) * currentAudio.duration;
      currentAudio.currentTime = newTime;
      setCurrentTime((prev) => {
        const updatedTimes = [...prev];
        updatedTimes[index] = newTime;
        return updatedTimes;
      });
    }
  };
  
  const stopAllAudio = () => {
    audioRefs.current.forEach((audio) => {
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
    setPlaying(null);
  };
  
  const handleClose = () => {
    stopAllAudio();
    onCancel();
  };

  const handleLoadedMetadata = (index: number) => {
    const currentAudio = audioRefs.current[index];
    if (currentAudio) {
      setDurations((prev) => {
        const updatedDurations = [...prev];
        updatedDurations[index] = currentAudio.duration;
        return updatedDurations;
      });
    }
  };

  return (
    <Modal
      open={visible}
      onOk={() => {
        stopAllAudio();
        onOk();
      }}
      onCancel={handleClose}
      footer={null}
      centered
      width={600}
    >
      <Row style={{ marginBottom: '24px' }}>
        <MyText color='#0A033C' size={32} weight={800} style={{ fontFamily: 'Nunito' }}>
        {`${t("materials")}`}
        </MyText>
      </Row>
      {/* {audioFiles.map((file, index) => (
        <Row key={index} >
          <Row style={{ marginBottom: '16px' }}>
            <MyText color='rgba(38, 38, 38, 1)' size={18} weight={800} style={{ fontFamily: 'Nunito' }}>
              {file.title}
            </MyText>
          </Row>

          <AudioContainer>
            <Row style={{ alignItems: 'center' }}>
              <AudioIcon style={{ marginRight: '16px' }} />
              <PlayPauseButton onClick={() => handlePlayPause(index, file.src)}>
                {playing === file.src ? <AudioPauseIcon /> : <AudioPlayIcon />}
              </PlayPauseButton>
            </Row>

            <Row style={{ alignItems: 'center', flex: 1 }}>
              <MyText color='rgba(104, 114, 125, 1)' weight={400} style={{ fontFamily: 'Nunito', marginRight: '16px' }}>
                {formatTime(currentTime[index])} / {formatTime(durations[index])}
              </MyText>

              <ProgressBar
                type="range"
                min="0"
                max="100"
                value={
                  currentTime[index]
                  ? (currentTime[index] / (audioRefs.current[index]?.duration || 1)) * 100
                  : 0
                }
                onChange={(e) => handleSeek(index, Number(e.target.value))}
                style={{ marginRight: '16px' }}
              />
              <SpeakerIcon />
            </Row>

            <audio
              ref={(el) => (audioRefs.current[index] = el!)}
              onTimeUpdate={() => handleTimeUpdate(index)}
              onLoadedMetadata={() => handleLoadedMetadata(index)}
              onEnded={() => setPlaying(null)}
            >
              <source src={file.src} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          </AudioContainer>
        </Row>
      ))} */}
          <MyText color='rgba(38, 38, 38, 1)' size={18} weight={800} style={{ fontFamily: 'Nunito' }}>
          {`${t("materialsNotAvailable")}`}

            </MyText>
        <Row justify="center">
        <StyledButton onClick={handleClose}>
        {`${t("close")}`}
        </StyledButton>
        </Row>
    </Modal>
  );
};
